import { Box, Link, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ArrowUpRight } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";
import { contentWidth, eyebrow } from "features/landing/landingStyles";

const footerLink = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 3,
  minHeight: 44,
  color: "grey.300",
  fontSize: "0.875rem",
  transition: "color 180ms ease",
  "&:hover": { color: "white.main" },
};

export default function LandingFooter() {
  return (
    <Box component="footer" sx={{ bgcolor: "dark.focus", color: "white.main" }}>
      <Box sx={contentWidth}>
        <Box
          sx={(theme) => ({
            height: "1px",
            background: `linear-gradient(90deg, ${theme.palette.accent.main}, ${alpha(
              theme.palette.primary.main,
              0.5
            )} 35%, ${alpha(theme.palette.white.main, 0.08)})`,
          })}
        />
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 4, sm: 8 }}
          sx={{ pt: { xs: 5, md: 7 }, pb: { xs: 4, md: 6 } }}
        >
          <Box>
            <Typography sx={{ ...eyebrow, color: "grey.400", mb: 2 }}>
              MENOS TIEMPO PLANIFICANDO.
            </Typography>
            <Link
              component={RouterLink}
              to="/"
              aria-label="Gymplanner, inicio"
              sx={{
                display: "inline-block",
                color: "white.main",
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                fontWeight: 700,
                lineHeight: 1.1,
                letterSpacing: "-0.06em",
              }}
            >
              Gymplanner
              <Box component="span" sx={{ color: "accent.main" }}>
                .
              </Box>
            </Link>
            <Typography
              sx={{
                color: "grey.400",
                mt: 2,
                maxWidth: 320,
                fontSize: "0.875rem",
                lineHeight: 1.7,
              }}
            >
              Crea rutinas completas en minutos.
              <br />
              Todo lo que necesitas, en un solo planner.
            </Typography>
          </Box>
          <Box
            component="nav"
            aria-label="Navegación del pie de página"
            sx={{ minWidth: 180, width: { xs: "100%", sm: "auto" } }}
          >
            <Typography sx={{ ...eyebrow, color: "grey.400", mb: 1.5 }}>EXPLORA</Typography>
            <Stack>
              <Link href="#funcionalidades" sx={footerLink}>
                Funcionalidades
                <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
              <Link href="#contacto" sx={footerLink}>
                Contacto
                <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
              <Link component={RouterLink} to="/planner/new" sx={footerLink}>
                Planificador
                <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
              <Link component={RouterLink} to="/programs" sx={footerLink}>
                Mis rutinas
                <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
            </Stack>
          </Box>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={(theme) => ({
            borderTop: `1px solid ${alpha(theme.palette.white.main, 0.1)}`,
            py: 2.5,
          })}
        >
          <Box
            aria-hidden="true"
            sx={{ width: 5, height: 5, borderRadius: "50%", bgcolor: "accent.main" }}
          />
          <Typography sx={{ color: "grey.400", fontSize: "0.75rem" }}>
            Rapidez para planificar.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}
